document.addEventListener("DOMContentLoaded", function() {
  var thumbSwiper = new Swiper(".custom_featured_product .thumbSwiper", {
    spaceBetween: 19,
    slidesPerView: 6,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      769: { 
        direction: "horizontal",
      },
      481: { 
        direction: "horizontal",
      },
0: { 
          slidesPerView: 3.5,
      }
    }
  });

  var featuredSwiper = new Swiper(".custom_featured_product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });


$('.product__color-chips').on('click', function () {
 var img_datat = $(this).find('.title_price_cover img').attr('src');
    // console.log(img_datat);
   $('.thumbnails_image .swiper-slide').each(function(index) {
      var imgDataSlide = $(this).find('img').attr('src'); 
     console.log('imgDataSlide', imgDataSlide);
      if (imgDataSlide === img_datat) {
// alert(imgDataSlide);
 featuredSwiper.slideTo(index); 
        return false; 
      }
    }); 

});  


$(document).ready(function () {
    $(".button_add_cart ").click(function () {

$('.btn_submit_data').click();
    });
});


$(".read_more").on("click", function() {
$('.desc1').hide();
$('.desc2').show();
        
});

$(".read_less").on("click", function() {
$('.desc1').show();
$('.desc2').hide();
        
});





});



